import {AgencyRepositoryType} from "../../../repositories/interfaces/AgencyRepositoryType.ts";
import {AgencyObservation} from "../../entities/Agency.ts";

export class GetAgencyObservationsUseCase {
    constructor(private readonly agencyRepository: AgencyRepositoryType) {}

    execute(agencyId: string): Promise<AgencyObservation[]> {
        return this.agencyRepository.getAgencyObservations(agencyId)
    }
}
